import React from 'react';
import Anchor from '../../objects/Anchor'

const CoursesCard = (props) => {

    const {image, title, description, uid} = props.coursesData;
    const url = '/training/courses'
    const clever = props.clever === true ? 'clever' : '';
    let card;

    switch(props.length)
    {
        case 1: card = ''
            break;
        case 2: card = 'col-sm-6'
            break;
        case 3: card = 'col-xl-4'
            break;
        default: card = 'col-sm-6 col-xl-3'
    }

    return (     
      <div className={`col-12 ${card} base-card courses-card ${clever}`}>
            <Anchor path={`${url}/${uid}`} internal anchorClass="card-inner">
                <div className="theme-courses-head">
                    <div className="image"
                         style={{backgroundImage: `url(${image})`}}></div>
                </div>
                <div className="theme-courses-body">
                    <div className="theme-courses-body-inner">
                        <h3 className="heading-three">{title}</h3>
                        <p className="body-copy card-copy">{description}</p>
                        <span className="theme-button">Read more</span>
                    </div>
                </div>
            </Anchor>
        </div>
    );
};

export default CoursesCard;


// WEBPACK FOOTER //
// src/client/components/dashboardNew/components/cards/CoursesCard.js